import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { fetchManufacturers } from "app/services/dashboard/manufacturerService";
import { BASE_URL } from "static/constants";

export const manufacturerApi = createApi({
  reducerPath: "manufacturerApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ query }) => ({
    getManufacturers: query({
      queryFn: () => {
        return { data: fetchManufacturers() };
      },
    }),
  }),
});

export const { useGetManufacturersQuery } = manufacturerApi;
